<template>
  <Loading />
  <HeaderPort />
  <div class="main-container" v-if="!loading">
    <div class="heading-container" v-if="translations">
      <HeadingPort />
      <FilterWorld />
      <LegendPort />
    </div>
    <Restaurants />
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import HeaderPort from '@/components/HeaderPort.vue'
import HeadingPort from '@/components/HeadingPort.vue'
import FilterWorld from '@/components/FilterWorld.vue'
import LegendPort from '@/components/LegendPort.vue'
import Restaurants from '@/components/Restaurants.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  components: {
    Loading,
    HeaderPort,
    HeadingPort,
    FilterWorld,
    LegendPort,
    Restaurants
  },
  computed: {
    ...mapState(['loading', 'translations'])
  },
  methods: {
    ...mapMutations(['changLoading']),
    ...mapActions(['getChangeLanguages'])
  },
  created () {
    this.getChangeLanguages()
    setTimeout(() => {
      this.changLoading(false)
    }, 1000)
  }
}
</script>

<style>
#app {
  font-family: Poppins,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.main-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  padding-left: 4%;
  padding-right: 4%;
}
.heading-container {
  max-width: 600px;
  padding-top: 7.5rem;
  padding-left: 6%;
  padding-right: 6%;
}
</style>
